import { render } from "./NextProjectThree.vue?vue&type=template&id=8d1d987c"
import script from "./NextProjectThree.vue?vue&type=script&lang=js"
export * from "./NextProjectThree.vue?vue&type=script&lang=js"

import "./NextProjectThree.vue?vue&type=style&index=0&id=8d1d987c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__